import { getAuth, signInWithPopup, OAuthProvider, getAdditionalUserInfo } from "firebase/auth";
import { showNotification } from "../../redux/slices/notificationSlice";
import { OauthSignInFucntion } from "../../assets/interfaces/interfaces";
import { v4 as uuidv4 } from "uuid";
import { closeAuthModal } from "../../redux/slices/userSlice";
import { logClickEvent } from "../../analytics";

// Function to handle Microsoft Sign-In
export const signInWithMicrosoft: OauthSignInFucntion = async (closeModal, dispatch, navigate) => {
  try {
    const auth = getAuth();
    const provider = new OAuthProvider("microsoft.com");
    const result = await signInWithPopup(auth, provider);
    const credential = OAuthProvider.credentialFromResult(result);
    const token = credential && credential.accessToken;
    const user = result.user;
    // Check if this is a new user and log signup event
    const additionalUserInfo = getAdditionalUserInfo(result);
    const isNewUser = additionalUserInfo?.isNewUser;

    if (navigate) {
      const newSessionId = uuidv4();
      navigate(`/chat/${newSessionId}`);
    }

    if (isNewUser) {
      // Log successful signup event for new users
      logClickEvent("sign_up", { method: "microsoft" });
    }

    dispatch(showNotification({ message: "Sign In Successful!", severity: "success", horizontal: "right" }));
    closeModal();
    dispatch(closeAuthModal());
    return { token, user };
  }
  catch (error) {
    console.log({ error }, "in sign in with Microsoft");
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    const email = error.email; // Email might not be available in the case of Microsoft
    const credential = OAuthProvider.credentialFromError(error);
    dispatch(showNotification({ message: errorMessage, severity: "error", horizontal: "right" }));
    return { errorCode, errorMessage, email, credential };
  }
};
